import { DisponibilidadHoraria } from '../../domain/entities/DisponibilidadHoraria';
import { DisponibilidadHorariaRepository } from '../../domain/repositories/DisponibilidadHorariaRepository';

export class MockDisponibilidadHorariaRepository implements DisponibilidadHorariaRepository {
  async validarDiaHabil(_fecha: string): Promise<DisponibilidadHoraria> {
    return { esNoHabil: false, mensaje: '' };
  }
}
